/* Tatagaltier header wishlist badge — mirrors the cart count bubble.
   Count comes from localStorage (`tata:wishlist`); hydrates on every page and
   updates on the `tata:wishlist:change` event and cross-tab `storage` events. */
(function () {
  var KEY = 'tata:wishlist';

  function count() {
    try { var l = JSON.parse(localStorage.getItem(KEY)); return Array.isArray(l) ? l.length : 0; }
    catch (e) { return 0; }
  }

  function render() {
    var bubble = document.querySelector('[data-wishlist-bubble]');
    if (!bubble) return;
    var n = count();
    if (n > 0) {
      bubble.textContent = n < 100 ? n : '99+';
      bubble.hidden = false;
    } else {
      bubble.textContent = '';
      bubble.hidden = true;
    }
  }

  render();
  document.addEventListener('tata:wishlist:change', render);
  window.addEventListener('storage', function (e) { if (e.key === KEY) render(); });
})();
